import {getBaseFileName} from "../../utils/GetBaseFileName";

export const nameDisplay = (archivedFile_url, isBulkLoad) => {
    if (archivedFile_url !== null && !isBulkLoad) {
        const lastIndex = archivedFile_url.lastIndexOf('/')
        const fileName = archivedFile_url.substring(lastIndex + 1)
        return fileName.length > 0 ? getBaseFileName(fileName) : '(filename unknown)'
    } else if (archivedFile_url === null) {
        return '(filename unknown)'
    }

    const lastIndex = archivedFile_url.lastIndexOf('p_ftp=')
    return lastIndex > 0 ? archivedFile_url.substring(lastIndex + 'p_ftp='.length):'(ftp unknown)' ;
}